export const loadStates = {
  loading: "loading",
  loaded: "loaded",
  error: "error",
  invalidated: "invalidated"
};
